import Spinner from 'shared/components/spinners/Spinner';
import Panel from 'shared/components/panels/Panel';

const PanelSpinner = () => {
  return (
    <Panel>
      <Spinner/>
    </Panel>
  );
};

export default PanelSpinner;
